import { getCurrentPermissions } from '../AppShell/Authentication/AuthorisationAsync';
import { AuthState } from '../AppShell/Authentication/AuthorisationModels';
import { ServicesAustraliaPermissions } from '../ServicesAustraliaPermissions';

export type AllApplicationPermissions = ServicesAustraliaPermissions;

export interface Permission {
    definitionCode: ServicesAustraliaPermissions;
    state: AuthState;
}

let permissions: Permission[];

export async function loadAuthorisationPermissions() {
    const newPermissions = await getCurrentPermissions();
    setAuthorisationPermissions(newPermissions);
}

export function setAuthorisationPermissions(newPermissions: Permission[]) {
    permissions = newPermissions ?? [];
}

export function getAuthorisationPermissions(): Permission[] {
    if (permissions) return permissions;

    throw new Error(
        'No authorisation permissions, please make sure your application calls setAuthorisationPermissions'
    );
}
